import "./slipStyles.css";
import { useSelector } from 'react-redux'
import { selectCurrentAddressLabelData } from '../app/features/memberReportSlice'
import { Button } from '@mui/material';

const getSalutation = (value) => {
    switch (value) {
        case 0: return "Mr.";
        case 1: return "Ms.";
        case 2: return "Dr.";
        default: return "";
    }
};

const AddressLabelPreviewALL = () => {
    const data = useSelector(selectCurrentAddressLabelData);
    const teacherData = data.find(d => d.membershipType === 'Individual Teacher Membership')
    const studentData = data.find(d => d.membershipType === 'Individual Student Membership')
    const InstitutionalData = data.find(d => d.membershipType === 'Institutional Membership')
    const corporateData = data.find(d => d.membershipType === 'Corporate Membership')
    const dualTeacherData = data.find(d => d.membershipType === 'Dual Teacher Membership')
    const params = new URLSearchParams(window.location.search);
    const includes = params.getAll('includes'); // ["Active_Membership", "Expired_Membership", "Renewed_Membership"]
    // Remove underscores
    const formattedIncludes = includes.map(item =>
        item.replace(/_/g, ' ')
    );
    // Teacher data filtering
    const membershipData = teacherData?.planTypes || [];

    const mapKey = {
        'New Membership': 'newMembers',
        'Renewed Membership': 'renewalMembers',
        'Expired Membership': 'expiredMembers',
        'Active Membership': 'activeMembers'
    };

    const teacherMembershipData = Object.entries(mapKey)
        .filter(([label]) => formattedIncludes.includes(label))
        .flatMap(([_, key]) =>
            membershipData.flatMap(d =>
                d[key].map(member => ({
                    ...member,
                    membershipType: d.membershipPlan,
                }))
            )
        ).filter(
            (item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
        );
    // student data filtering
    const stuMembershipData = studentData?.planTypes || [];

    const studentMembershipData = Object.entries(mapKey)
        .filter(([label]) => formattedIncludes.includes(label))
        .flatMap(([_, key]) =>
            stuMembershipData.flatMap(d =>
                d[key].map(member => ({
                    ...member,
                    membershipType: d.membershipPlan,
                }))
            )
        ).filter(
            (item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
        );
    // Institutional data filtering
    const instMembershipData = InstitutionalData?.planTypes || [];


    const InstitutionalMembershipData = Object.entries(mapKey)
        .filter(([label]) => formattedIncludes.includes(label))
        .flatMap(([_, key]) =>
            instMembershipData.flatMap(d =>
                d[key].map(member => ({
                    ...member,
                    membershipType: d.membershipPlan,
                }))
            )
        ).filter(
            (item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
        );
    // Corporate data filtering
    const corpoMembershipData = corporateData?.planTypes || [];

    const corporateMembershipData = Object.entries(mapKey)
        .filter(([label]) => formattedIncludes.includes(label))
        .flatMap(([_, key]) =>
            corpoMembershipData.flatMap(d =>
                d[key].map(member => ({
                    ...member,
                    membershipType: d.membershipPlan,
                }))
            )
        ).filter(
            (item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
        );

    // Dual teacher data filtering
    const dualMembershipData = dualTeacherData?.planTypes || [];

    const dualTeacherMembershipData = Object.entries(mapKey)
        .filter(([label]) => formattedIncludes.includes(label))
        .flatMap(([_, key]) =>
            dualMembershipData.flatMap(d =>
                d[key].map(member => ({
                    ...member,
                    membershipType: d.membershipPlan,
                }))
            )
        ).filter(
            (item, index, self) =>
                index === self.findIndex((t) => t._id === item._id)
        );

    return (
        <>
            <div className="pt-5 d-print-none">
                <div className="chapter-heading ">
                    <h2 className="text-center title-font text-light py-3 mt-1">
                        Address Labels for Print
                    </h2>
                </div>
            </div>
            <div className="p-md-5 p-3 overallPadding">
                <div className="text-end mb-3 no-print">
                    <Button
                        onClick={() => window.history.back()}
                        variant="contained"
                        className="menus-color"
                    >
                        Back
                    </Button>
                </div>
                {teacherMembershipData.length > 0 && <div className='w-100'>
                    <p className='d-block text-center fw-bold'>Individual Teacher Membership</p>
                </div>}
                <div className="print-container">
                    {teacherMembershipData.map((user, index) => {
                        const plan = user.plans.findLast(p => p.isPaid === 1) || {};
                        return (
                            <>
                                <div className="slip-box" key={user._id}>
                                    <div className="plan-header">
                                        Individual Teacher Membership <br />{user?.membershipType} Plan &nbsp;
                                        <strong> ID:  {user.userId}</strong>

                                    </div>
                                    <div className="to-address">
                                        <div className='d-flex justify-content-between'>
                                            <strong>To</strong> <div className="expires">Expires on {new Date(plan.planEndDate).toLocaleDateString('en-GB', {
                                                year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
                                            })}</div>
                                        </div>

                                        {getSalutation(user.salutation)} <strong className='text-capitalize'>{user.fullName}</strong><br />
                                        <span className="address-text">{user.address.toLowerCase()}, {user.city.toLowerCase()}, {user.district ? `${user.district.toLowerCase()}, ` : ' '}{user.state.toLowerCase()}</span><br />
                                        <strong>PIN - {user.pinCode}</strong> &nbsp;
                                        <div className='d-flex justify-content-between'>
                                            <span>Mobile: <strong>{user.mobileNumber}</strong></span><span className="text-secondary">{index + 1}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
                <hr className='no-print fw-bold text-dark opacity-75 w-100' />
                {studentMembershipData.length > 0 && <div className='w-100 page-break fw-bold'>
                    <p className='d-block text-center'>Individual Student Membership</p>
                </div>}
                <div className="print-container">
                    {studentMembershipData.map((user, index) => {
                        const plan = user.plans.findLast(p => p.isPaid === 1) || {};
                        return (
                            <>
                                <div className="slip-box" key={user._id}>
                                    <div className="plan-header">
                                        Individual Student Membership <br />{user?.membershipType} Plan &nbsp;
                                        <strong> ID:  {user.userId}</strong>

                                    </div>
                                    <div className="to-address">
                                        <div className='d-flex justify-content-between'>
                                            <strong>To</strong> <div className="expires">Expires on {new Date(plan.planEndDate).toLocaleDateString('en-GB', {
                                                year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
                                            })}</div>
                                        </div>

                                        {getSalutation(user.salutation)} <strong className='text-capitalize'>{user.fullName}</strong><br />
                                        <span className="address-text">{user.address.toLowerCase()}, {user.city.toLowerCase()}, {user.district ? `${user.district.toLowerCase()}, ` : ' '}{user.state.toLowerCase()}</span><br />
                                        <strong>PIN - {user.pinCode}</strong> &nbsp;
                                        <div className='d-flex justify-content-between'>
                                            <span><strong>Mobile: </strong>{user.mobileNumber}</span><span className="text-secondary">{index + 1}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
                <hr className='no-print fw-bold text-dark opacity-75 w-100' />
                {dualTeacherMembershipData.length > 0 && <div className='w-100 page-break fw-bold'>
                    <p className='d-block text-center'>Dual Teacher Membership</p>
                </div>}
                <div className="print-container">
                    {dualTeacherMembershipData.map((user, index) => {
                        const plan = user.plans.findLast(p => p.isPaid === 1) || {};
                        return (
                            <>
                                <div className="slip-box" key={user._id}>
                                    <div className="plan-header">
                                        Dual Teacher Membership <br />{user?.membershipType} Plan &nbsp;
                                        <strong> ID:  {user.userId}</strong>

                                    </div>
                                    <div className="to-address">
                                        <div className='d-flex justify-content-between'>
                                            <strong>To</strong> <div className="expires">Expires on {new Date(plan.planEndDate).toLocaleDateString('en-GB', {
                                                year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
                                            })}</div>
                                        </div>

                                        {getSalutation(user.salutation)} <strong className='text-capitalize'>{user.fullName}</strong><br />
                                        <span className="address-text">{user.address.toLowerCase()}, {user.city.toLowerCase()}, {user.district ? `${user.district.toLowerCase()}, ` : ' '}{user.state.toLowerCase()}</span><br />
                                        <strong>PIN - {user.pinCode}</strong> &nbsp;
                                        <div className='d-flex justify-content-between'>
                                            <span><strong>Mobile: </strong>{user.mobileNumber}</span><span className="text-secondary">{index + 1}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
                <hr className='no-print fw-bold text-dark opacity-75 w-100' />
                {InstitutionalMembershipData.length > 0 && <div className='w-100 page-break fw-bold'>
                    <p className='d-block text-center'>Institutional Membership</p>
                </div>}
                <div className="print-container">
                    {InstitutionalMembershipData.map((user, index) => {
                        const plan = user.plans.findLast(p => p.isPaid === 1) || {};
                        return (
                            <>
                                <div className="slip-box" key={user._id}>
                                    <div className="plan-header">
                                        Institutional Membership<br />{user?.membershipType} Plan &nbsp;
                                        <strong> ID:  {user.userId}</strong>
                                    </div>
                                    <div className="to-address">
                                        <div className='d-flex justify-content-between'>
                                            <strong>To</strong> <div className="expires">Expires on {new Date(plan.planEndDate).toLocaleDateString('en-GB', {
                                                year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
                                            })}</div>
                                        </div>
                                        {user.addressedTo} <br /> <strong className='text-capitalize'>{user.institution}</strong><br />
                                        <span className='address-text'>{user.address.toLowerCase()}, {user.city.toLowerCase()}, {user.district ? `${user.district.toLowerCase()}, ` : ' '}{user.state.toLowerCase()}</span><br />
                                        <strong>PIN - {user.pinCode}</strong> &nbsp;
                                        <div className='d-flex justify-content-between'>
                                            <span><strong>Mobile: </strong>{user.mobileNumber}</span><span className="text-secondary">{index + 1}</span>
                                        </div>
                                    </div>
                                    <div className="slip-footer"></div>
                                </div>
                            </>
                        );
                    })}
                </div>
                <hr className='no-print fw-bold text-dark opacity-75 w-100' />
                {corporateMembershipData.length > 0 && <div className='w-100 page-break fw-bold'>
                    <p className='d-block text-center'>Corporate Supporter MemberShip</p>
                </div>}
                <div className="print-container">
                    {corporateMembershipData.map((user, index) => {
                        const plan = user.plans.findLast(p => p.isPaid === 1) || {};
                        return (
                            <>
                                <div className="slip-box" key={user._id}>
                                    <div className="plan-header">
                                        Corporate Supporter MemberShip<br />{user?.membershipType} Plan &nbsp;
                                        <strong> ID:  {user.userId}</strong>
                                    </div>
                                    <div className="to-address">
                                        <div className='d-flex justify-content-between'>
                                            <strong>To</strong> <div className="expires">Expires on {new Date(plan.planEndDate).toLocaleDateString('en-GB', {
                                                year: 'numeric', month: '2-digit', day: '2-digit', formatMatcher: 'basic'
                                            })}</div>
                                        </div>
                                        {user.addressedTo} <br /> <strong className='text-capitalize'>{user.organisationName}</strong><br />
                                        <span className='address-text'>{user.address.toLowerCase()}, {user.city.toLowerCase()}, {user.district ? `${user.district.toLowerCase()}, ` : ' '}{user.state.toLowerCase()}</span><br />
                                        <strong>PIN - {user.pinCode}</strong> &nbsp;
                                        <div className='d-flex justify-content-between'>
                                            <span><strong>Mobile: </strong>{user.mobileNumber}</span><span className="text-secondary">{index + 1}</span>
                                        </div>
                                    </div>
                                    <div className="slip-footer"></div>
                                </div>
                            </>
                        );
                    })}
                </div>
                <div className="text-center my-3 w-100 d-flex gap-3 justify-content-between">
                    <Button
                        onClick={() => window.history.back()}
                        variant="contained"
                        className="menus-color d-print-none"
                    >
                        Back to Generate label form
                    </Button>
                    <Button
                        onClick={() => window.print()}
                        variant="contained"
                        className="rounded-0 d-print-none"
                        color="primary"
                    >
                        Print
                    </Button>
                </div>
            </div>
        </>
    );
};

export default AddressLabelPreviewALL;
